import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import TargetedMultiActionDetails from './TargetedMultiActionDetails';
import FindLocalRep from '../LocalRep/FindLocalRep';

const TargetedMultiAction = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.pathname} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/targetedMultiAction"
                            name="TargetedMultiActionDetails"
                            exact
                            component={TargetedMultiActionDetails}
                        />
                        <Route
                            path="/targetedMultiAction/findRep"
                            name="TargetedFindRep"
                            exact
                            component={FindLocalRep}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default TargetedMultiAction;
